export { LEAD_MAGNET_PAGES } from './lead-magnets/config'
export type { LeadMagnetPage, LeadMagnetFormField, LeadMagnetPageWithScheduleCTA } from './lead-magnets/config'

export { LeadMagnetTemplate } from './lead-magnets/components/LeadMagnetTemplate'
export { LeadMagnetSchedule } from './lead-magnets/components/LeadMagnetSchedule'
export { LeadCaptureForm } from './lead-magnets/components/LeadCaptureForm'
export type { CreateLeadMagnetLeadFn } from './lead-magnets/components/LeadCaptureForm'
export { PhoneDisclosure, PhoneDisclosureBody } from './lead-magnets/components/PhoneDisclosure'

export { loadLeadMagnetQualification, INVESTABLE_ASSETS_OPTIONS } from './utils/lead-magnet-qualification'
export {
  clearLeadMagnetUnlockCookie,
  hasLeadMagnetUnlockCookie,
  setLeadMagnetUnlockCookie,
} from './utils/lead-magnet-unlock'
export { useLeadMagnetUnlocked } from './hooks/use-lead-magnet-unlocked'
export { useClientMounted } from './hooks/use-client-mounted'

export type { LeadMagnetSchema } from './lib/lead-magnet-schema'

export { LeadMagnetAdCard } from './chrome/LeadMagnetAdCard'
export { ScheduleStickyBar } from './chrome/ScheduleStickyBar'
export { LeadMagnetScheduleCTA } from './chrome/LeadMagnetScheduleCTA'

export { ButtonCTA } from './controls/ButtonCTA'
export { ScheduleCallCTA } from './controls/ScheduleCallCTA'
export { NumberInput } from './controls/NumberInput'
export type { NumberInputProps } from './controls/NumberInput'
export { RangeSelectInput } from './controls/RangeSelectInput'

export {
  clearSchedulePrefill,
  loadCalendlyPrefill,
  loadScheduleFormPrefill,
  saveSchedulePrefill,
} from './utils/schedule-prefill'
export type { SchedulePrefill } from './utils/schedule-prefill'

export {
  CTA,
  PAID_MEDIA_CALENDLY_URL,
  IPO_STRATEGY_CALENDLY_URL,
  FREE_EQUITY_STRATEGY_CALENDLY_URL,
  WEALTH_CHECK_CALENDLY_URL,
  ANONYMOUS_TRACKING_SNAPSHOT_CALENDLY_URLS,
  calendlyUsesAnonymousTrackingSnapshot,
  SCHEDULE_CALENDLY_URL_PARAM,
  SCHEDULE_TRACKING_OPTIONS,
  buildScheduleRedirectUrl,
} from './utils/ctas'
export { getTrackingParams } from './utils/tracking'

export { WealthCheckContent } from './tools/wealth-check/WealthCheckContent'
export type { CreateWealthCheckLeadFn } from './tools/wealth-check/WealthCheckContent'

export { CoastFireCalculator } from './tools/coast-calc/CoastFireCalculator'
export { SpendCheckContent } from './tools/spend-check/_components/SpendCheckContent'
export { CareerBreakCalculator } from './tools/career-break/_components/CareerBreakCalculator'
export { OnTrackPageContent } from './tools/ontrack/_components/OnTrackPageContent'
export type { OnTrackCalculatorProps } from './tools/ontrack/_components/OnTrackCalculator'
export { RentVsBuyCalculator } from './tools/rent-vs-buy/_components/RentVsBuyCalculator'

export { ExemplarContent } from './landing/lp-exemplar/ExemplarContent'

export { Section } from './chrome/Section'
export { LINKS } from './utils/links'
export { getFileFromNwCDN } from './utils/nw-cdn'
export { getAnonymousId } from './utils/local-storage'
export { fmtCurrency, fmtFullCurrency, parseCurrency } from './utils/currency-format'
